// @flow

import * as React from "react";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

type PropsType = {
    tiles: React.ReactNode[],
    duration: number,
};

const CustomDot = ({ onClick, ...rest }) => {
    const {
        index,
        carouselState: { currentSlide },
    } = rest;
    return (
        <button
            className={`tile-carousel__indicator ${
                index === currentSlide ? "tile-carousel__indicator--active" : ""
            } ${index < currentSlide ? "tile-carousel__indicator--full" : ""} ${
                index > currentSlide ? "tile-carousel__indicator--empty" : ""
            }`}
            onClick={() => onClick()}
            title={`Go to slide ${index + 1}`}
        >
            <div className="tile-carousel__indicator__bar"></div>
        </button>
    );
};

const TileCarousel = (props: PropsType): React.Node => {
    const [currentSlideIdx, setCurrentSlideIdx] = React.useState(0);

    const responsive = {
        default: {
            breakpoint: { max: 9999, min: 0 },
            items: 1,
        },
    };

    const colors = []; //unused feature to change color of indicator bars

    return (
        <div
            className="tile-carousel"
            style={{
                "--duration": `${props.duration}ms`,
                "--barColor": `${colors[currentSlideIdx]}cc`,
                "--barColorInactive": `${colors[currentSlideIdx]}55`,
            }}
        >
            {props.tiles ? (
                <Carousel
                    autoPlay
                    autoPlaySpeed={props.duration}
                    rewind
                    showDots={props.tiles?.length > 1}
                    customDot={<CustomDot />}
                    renderDotsOutside
                    rewindWithAnimation
                    arrows={false}
                    responsive={responsive}
                    shouldResetAutoplay={true}
                    itemClass="tile-carousel__item"
                    renderButtonGroupOutside={true}
                    // beforeChange={(nextSlide, { currentSlide, onMove }) => {
                    //     setTimeout(() => {
                    //         setCurrentSlideIdx(nextSlide);
                    //     }, 50);
                    // }}
                >
                    {props.tiles.map((item, index) => {
                        return <div key={index}>{item}</div>;
                    })}
                </Carousel>
            ) : null}
        </div>
    );
};

export default TileCarousel;
